import { format, formatDistanceToNowStrict, isSameYear, isToday, isYesterday } from "date-fns"
import { ru } from "date-fns/locale/ru"

/** «12 сентября в 14:02», год только если не текущий. */
export function formatWhen(value: string | Date): string {
	const date = new Date(value)
	if (isToday(date)) return `сегодня в ${format(date, "HH:mm")}`
	if (isYesterday(date)) return `вчера в ${format(date, "HH:mm")}`
	return format(date, isSameYear(date, new Date()) ? "d MMMM 'в' HH:mm" : "d MMMM yyyy 'в' HH:mm", {
		locale: ru,
	})
}

/** «12 сен», «12 сен 2025»: для таблиц, где важна дата, а не минута. */
export function formatShortDate(value: string | Date): string {
	const date = new Date(value)
	return format(date, isSameYear(date, new Date()) ? "d MMM" : "d MMM yyyy", { locale: ru })
}

/** «3 дня назад». */
export function formatAgo(value: string | Date): string {
	return formatDistanceToNowStrict(new Date(value), { locale: ru, addSuffix: true })
}

/** Часовой пояс браузера для подписей к времени публикации. */
export const LOCAL_TIME_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone
